import { connect } from 'react-redux';
import CorrugatedMetal from './CorrugatedMetal';

import { getAnnualResults } from '../../selectors';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
});

const combinedActions = { };

export default connect(mapStateToProps, combinedActions)(CorrugatedMetal);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/CorrugatedMetal/index.js